import React, { useState } from "react";
import * as XLSX from "xlsx";

const ExcelHandler = ({ reference, onImport }) => {
  const [data, setData] = useState([]);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const sheetData = XLSX.utils.sheet_to_json(sheet);

      // Read "Email" column
      const extracted = sheetData
        .map(row => row.Email?.trim())
        .filter(x => x && x.includes("@"));

      // Remove duplicates
      const uniqueEmails = [...new Set(extracted)];

      console.log("Imported Emails:", uniqueEmails);

      setData(uniqueEmails);

      // Fill textarea list
      if (reference?.current) {
        reference.current.value = uniqueEmails.join("\n");
      }

      // Notify parent
      onImport && onImport(uniqueEmails);
    };

    reader.readAsBinaryString(file);
  };

  return (
    <div className="mt-2">
      <label className="block font-medium mb-1">Upload Excel (.xlsx)</label>
      <input type="file" accept=".xlsx,.xls" onChange={handleFileUpload} />

      {data.length > 0 && (
        <div className="mt-2 text-xs bg-gray-100 p-2 rounded border">
          <strong>Imported {data.length} emails:</strong>
          <pre className="whitespace-pre-wrap">{JSON.stringify(data, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default ExcelHandler;
